import cn from 'classnames';
import React from 'react';
import { Button, LinkButton, PrimaryButton } from 'app/blocks/buttons/buttons';
import DialogMessage from 'app/blocks/dialog/dialog__message';
import Modal from 'app/blocks/Modal/Modal';
import './ConfirmationDialog.scss';

type Props = {
    message: string;
    cancelBtnLabel: string;
    confirmBtnLabel: string;
    onReject: () => void;
    onApprove: () => void;
    title?: string;
    useButtonForConfirm?: boolean;
};

function ConfirmationDialog({
    cancelBtnLabel,
    confirmBtnLabel,
    message,
    onApprove,
    onReject,
    title,
    useButtonForConfirm = false,
}: Props): React.ReactElement {
    const type = 'affiliationConfirmation';
    const seleniumIdPrefix = `${type}Dialog`;

    const ConfirmComponent = useButtonForConfirm ? PrimaryButton : LinkButton;
    const confirmSeleniumId = useButtonForConfirm
        ? `${seleniumIdPrefix}-dialog-confirm-button`
        : `${seleniumIdPrefix}-dialog-confirm-link`;

    return (
        <Modal
            className={cn('Dialog', { 'Dialog--enhanced': useButtonForConfirm })}
            ignoreBackdropClicks
            modalHeading={title}
            onClose={onReject}
            type={type}
        >
            <div className="modal-body Dialog-Body" data-seleniumid="modal-body">
                <div className={useButtonForConfirm ? 'DialogMessage--left-aligned' : undefined}>
                    <DialogMessage html={message} type={type} />
                </div>
                <div className="Dialog-BodyActions Dialog-BodyActions-Column">
                    {useButtonForConfirm ? (
                        <>
                            <ConfirmComponent
                                className="noStretch"
                                data-seleniumid={confirmSeleniumId}
                                onClick={onApprove}
                            >
                                {confirmBtnLabel}
                            </ConfirmComponent>
                            <Button
                                className="noStretch"
                                data-seleniumid={`${seleniumIdPrefix}-dialog-cancel-button`}
                                onClick={onReject}
                            >
                                {cancelBtnLabel}
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                className="noStretch"
                                data-seleniumid={`${seleniumIdPrefix}-dialog-cancel-button`}
                                onClick={onReject}
                            >
                                {cancelBtnLabel}
                            </Button>
                            <ConfirmComponent data-seleniumid={confirmSeleniumId} onClick={onApprove}>
                                {confirmBtnLabel}
                            </ConfirmComponent>
                        </>
                    )}
                </div>
            </div>
        </Modal>
    );
}

ConfirmationDialog.defaultProps = {
    title: undefined,
    useButtonForConfirm: false,
};

export default ConfirmationDialog;
